/* icFedrampScreen.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./icFedrampScreen.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { Box } from '@atlaskit/primitives/compiled';
import { SCREEN_EVENT_TYPE } from '@atlaskit/analytics-gas-types';
import { icFedrampMessages } from './icFedrampMessages';
import lockSvg from './assets/lock.svg';
import { fg } from '@atlaskit/platform-feature-flags';
var styles = {
  container: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsb1vif _4t3i1rxh _1e0c1txw _4cvr1h6o _2lx21bp4 _1bah1h6o _kqswh2mm",
  closeButton: "_kqsw1n9t _154ipxbi _1xi2pxbi _1pby9y44",
  title: "_11c8lodh _19pkpxbi _otyrpxbi _y3gn1h6o",
  message: "_y3gn1h6o _otyr1ejb"
};
export var IcFedrampScreen = function IcFedrampScreen(_ref) {
  var onAnalyticsEvent = _ref.onAnalyticsEvent;
  var fireScreenEvent = useCallback(function () {
    if (onAnalyticsEvent) {
      onAnalyticsEvent({
        payload: {
          eventType: SCREEN_EVENT_TYPE,
          name: 'icFedrampScreen'
        },
        context: [{
          source: 'icFedrampScreen'
        }]
      });
    }
  }, [onAnalyticsEvent]);
  React.useEffect(function () {
    fireScreenEvent();
  }, [fireScreenEvent]);
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.container
  }, /*#__PURE__*/React.createElement("img", {
    src: lockSvg,
    alt: ""
  }), /*#__PURE__*/React.createElement(Box, {
    as: "h3",
    xcss: styles.title
  }, /*#__PURE__*/React.createElement(FormattedMessage, fg('product-terminology-refresh') ? icFedrampMessages.errorTitleAppify : icFedrampMessages.errorTitle)), /*#__PURE__*/React.createElement(Box, {
    as: "p",
    xcss: styles.message
  }, /*#__PURE__*/React.createElement(FormattedMessage, fg('product-terminology-refresh') ? icFedrampMessages.errorMessageAppify : icFedrampMessages.errorMessage)));
};
export default IcFedrampScreen;